module.exports = __webpack_public_path__ + "img/top_queries_1.3426fa3b.svg";